import { Bank } from './bank';
import { Deserializable } from './deserializable';
import { PrimaryContact } from './primary.contact';
import { Supplier } from './supplier';
import { UserAddress } from './user.address';
import { Wholesaler } from './wholesaler';

export class Enterprise implements Deserializable {
    public id!: string;
    public userId!: string;
    public roleId!: string;
    public userRoleId!: string;
    public businessName!: string;
    public employeeName!: string;
    public enterpriseId!: string;
    public enterpriseEmployeeId!: string;
    public status!: string;
    public kycLevel!: string;
    public createdAt!: string;
    public businessLogo!: string;
    public lastLogin!: string;
    public availableBalance!: string;
    public fullBalance!: string;
    public publicKey!: string;
    public code!: string;
    public visibleInPayList = false;
    public wholesalerEnabled = false;
    public supplierEnabled = false;
    public bank: Bank;
    public primaryContact: PrimaryContact;
    public supplier?: Supplier;
    public wholesaler?: Wholesaler;
    public address: UserAddress;

    constructor(data: Partial<Enterprise> = {}) {
        this.bank = new Bank();
        this.primaryContact = new PrimaryContact();
        this.address = new UserAddress();

        this.deserialize(data);
    }

    deserialize(input: any): this {
        if (!input) {
            return this;
        }

        Object.assign(this, input);

        this.bank = Object.assign(new Bank(), input.bank ?? {});
        this.primaryContact = Object.assign(new PrimaryContact(), input.primaryContact ?? {});
        this.address = new UserAddress(input.address ?? {});
        this.supplier = input.supplier ?? undefined;
        this.wholesaler = input.wholesaler ?? undefined;

        return this;
    }
}
